import React, { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getChatRoom } from '../../redux/slices/chatSlice'
import { useSocketConnection } from '../../helper/socket'
import RenderChatContent from './renderChatContent'
import ChatHeader from './chatHeader'

const Chat = () => {
  const endOfMessagesRef = useRef(null)
  const dispatch = useDispatch()
  const params = useParams()
  const chatRoomId = params?.room_id
  const userId = params?.user_id
  const { chatRoomInfo } = useSelector((state) => state?.chat)
  
  const { messages } = useSocketConnection(chatRoomId)

  useEffect(() => {
    if (userId) {
      dispatch(getChatRoom(userId))
    }
  }, [userId])

  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [messages])

  return (
    <div className="page-wrapper chat-wrapper">
      <div className="content container-fluid">
        <ChatHeader client={chatRoomInfo?.client} cleaners={chatRoomInfo?.cleaners} />
        <div className="chat-content">
          {messages.map((chat, index) => (
            <RenderChatContent chat={chat} key={index} endRef={endOfMessagesRef} />
          ))}
        </div>
      </div>
    </div>
  )
}
export default Chat
